"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalSeparationInputState = void 0;
var tslib_1 = require("tslib");
var input_state_1 = require("./input.state");
var VerticalSeparationInputState = /** @class */ (function (_super) {
    tslib_1.__extends(VerticalSeparationInputState, _super);
    function VerticalSeparationInputState(label) {
        return _super.call(this, label) || this;
    }
    VerticalSeparationInputState.prototype.validateInput = function (value) {
        if (value) {
            if (!value.drawableTop || !value.drawableBottom) {
                this.setError('error');
                return;
            }
        }
        this.setError(null);
    };
    return VerticalSeparationInputState;
}(input_state_1.InputState));
exports.VerticalSeparationInputState = VerticalSeparationInputState;
//# sourceMappingURL=vertical.separation.input.state.js.map